<template>
    <div class="btn-base btn-start" @click="$emit('click')" v-html="T('button_start').toUpperCase()">
    </div>
</template>
  
<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'StartButton',
    computed: {
        value: {
            cache: false,
            get(): string {
                return T("button_start");
            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        }
    }
});
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.btn-start {
    height: 88px;
    width: 266px;
    border-radius: 8px;
    background-color: #B2CD30;
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 48px;
    letter-spacing: 0.03px;
    line-height: 57px;
    text-align: center;
}
</style>
  